import React from 'react'
import { useTranslation } from 'react-i18next'

import withMemo from '../../decorators/withMemo'
import SubmitSchoolTemplate from '../../templates/SubmitSchool'
import { useHeader, useFooter } from '../../hooks/useAppLayout'
import { useNavPath } from '../../hooks/useNavPath'

import sagas from './sagas'


const SubmitSchool = () => {
  const { t } = useTranslation()
  const headerProps = useHeader()
  const footerProps = useFooter()
  const navPathProps = useNavPath()
  const layoutProps = {
    theme: {
      maxWidth: 640,
    },
  }
  const pageTitleProps = {
    text: t('submit_your_school'),
  }
  const paragraphProps = {
    text: t('submitschool_page_introduction'),
  }

  const submitSchoolTemplateProps = {
    headerProps,
    navPathProps,
    footerProps,
    layoutProps,
    pageTitleProps,
    paragraphProps,
  }


  return (<SubmitSchoolTemplate {...submitSchoolTemplateProps} />)
}

SubmitSchool.getInitialProps = async(ctx) => ctx.store.saga.run(sagas.init, ctx).toPromise()

SubmitSchool.propTypes = {}

SubmitSchool.defaultProps = {}

export default withMemo()(SubmitSchool)
